/* Progressive enhancement of one collection. Native catalogue stays usable without JS. */
(() => {
  const root = document.querySelector('[data-hw]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true'; root.dataset.hwReady = 'true'; root.classList.add('hw-ready');
  const $ = s => root.querySelector(s);
  const grid = $('[data-hw-products]'), count = $('[data-hw-count]');
  const status = $('[data-hw-status]'), retry = $('[data-hw-retry]');
  const nativePager = $('[data-hw-native-pagination]'), pager = $('[data-hw-client-pagination]');
  const empty = $('[data-hw-empty]'), search = $('#hw-query');
  const filters = [...root.querySelectorAll('[data-hw-filter]')];
  const total = Number(root.dataset.total), pages = Number(root.dataset.pages);
  const perPage = Number(root.dataset.perpage), nativePage = Number(root.dataset.page);
  const originals = [...grid.children].map(n => n.cloneNode(true));
  const originalCount = count.textContent;
  let cache = null, pending = null, epoch = 0, selectedPage = 1, matches = [];
  const url = new URL(location.href);
  search.value = (url.searchParams.get('hw_q') || '').slice(0, 160);
  filters.forEach(f => { const v = url.searchParams.get(`hw_${f.dataset.hwFilter}`); if ([...f.options].some(o => o.value === v)) f.value = v; });
  const fold = s => s.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const active = () => Boolean(search.value.trim() || filters.some(f => f.value));
  const stateUrl = () => {
    const u = new URL(location.href);
    const values = {q: search.value.trim(), ...Object.fromEntries(filters.map(f => [f.dataset.hwFilter, f.value]))};
    Object.entries(values).forEach(([k,v]) => v ? u.searchParams.set(`hw_${k}`, v) : u.searchParams.delete(`hw_${k}`));
    if (active() && selectedPage > 1) u.searchParams.set('hw_page', selectedPage); else u.searchParams.delete('hw_page');
    history.replaceState(null, '', u);
  };
  const restore = () => {
    grid.replaceChildren(...originals.map(n => n.cloneNode(true)));
    nativePager.hidden = false; pager.hidden = true; empty.hidden = total > 0;
    count.textContent = originalCount; root.dataset.matched = String(total);
  };
  const allModels = async () => {
    if (cache) return cache;
    if (pending) return pending;
    pending = (async () => {
      const byPage = new Map([[nativePage, originals]]);
      const queue = Array.from({length: pages}, (_,i) => i + 1).filter(p => p !== nativePage);
      const worker = async () => {
        while (queue.length) {
          const p = queue.shift(), u = new URL(location.href);
          [...u.searchParams.keys()].forEach(k => { if (k.startsWith('hw_')) u.searchParams.delete(k); });
          u.searchParams.set('section_id', root.dataset.section); u.searchParams.set('page', p);
          const controller = new AbortController(); const timer = setTimeout(() => controller.abort(), 35000);
          let response, html;
          try { response = await fetch(u, {credentials:'same-origin',signal:controller.signal}); if (!response.ok) throw new Error('Catalogue request failed'); html = await response.text(); }
          finally { clearTimeout(timer); }
          const doc = new DOMParser().parseFromString(html, 'text/html'), remote = doc.querySelector('[data-hw]');
          if (!remote || remote.dataset.total !== String(total) || Number(remote.dataset.page) !== p || remote.dataset.section !== root.dataset.section) throw new Error('Catalogue response mismatch');
          const cards = [...remote.querySelector('[data-hw-products]').children];
          if (cards.length !== Math.min(perPage, total - (p-1)*perPage)) throw new Error('Incomplete catalogue page');
          byPage.set(p, cards);
        }
      };
      await Promise.all([worker(), worker()]);
      const all = [...byPage.entries()].sort((a,b) => a[0]-b[0]).flatMap(x => x[1]);
      if (all.length !== total || new Set(all.map(x => x.dataset.hwProduct)).size !== total) throw new Error('Incomplete catalogue');
      cache = all; root.dataset.loaded = String(all.length); return all;
    })();
    try { return await pending; } finally { pending = null; }
  };
  const render = () => {
    selectedPage = Math.max(1, Math.min(selectedPage, Math.max(1, Math.ceil(matches.length/perPage))));
    grid.replaceChildren(...matches.slice((selectedPage-1)*perPage, selectedPage*perPage).map(n => n.cloneNode(true)));
    empty.hidden = matches.length > 0; nativePager.hidden = true; pager.hidden = matches.length <= perPage;
    $('[data-hw-prev]').disabled = selectedPage === 1;
    $('[data-hw-next]').disabled = selectedPage >= Math.ceil(matches.length/perPage);
    $('[data-hw-page-info]').textContent = `${root.dataset.pageLabel} ${selectedPage} / ${Math.max(1, Math.ceil(matches.length/perPage))}`;
    count.textContent = `${matches.length ? (selectedPage-1)*perPage+1 : 0}–${Math.min(selectedPage*perPage,matches.length)} / ${matches.length} ${root.dataset.matches}`;
    root.dataset.matched = String(matches.length); stateUrl();
  };
  const apply = async (keepPage = false) => {
    const current = ++epoch; if (!keepPage) selectedPage = 1;
    retry.hidden = true; stateUrl();
    if (!active()) { restore(); status.textContent = ''; grid.removeAttribute('aria-busy'); return; }
    status.textContent = root.dataset.loading; grid.setAttribute('aria-busy','true');
    try {
      const all = await allModels(); if (current !== epoch) return;
      const words = fold(search.value.trim()).split(/\s+/).filter(Boolean);
      matches = all.filter(n => words.every(w => fold(n.dataset.search).includes(w)) && filters.every(f => !f.value || n.dataset[f.dataset.hwFilter] === f.value));
      render(); status.textContent = ''; grid.removeAttribute('aria-busy');
    } catch (_) {
      if (current !== epoch) return;
      restore(); status.textContent = root.dataset.failed; retry.hidden = false; grid.removeAttribute('aria-busy');
    }
  };
  let timer;
  search.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => apply(), 250); });
  $('[data-hw-search]').addEventListener('submit', e => { e.preventDefault(); clearTimeout(timer); apply(); });
  filters.forEach(f => f.addEventListener('change', () => apply()));
  $('[data-hw-reset]').addEventListener('click', () => { search.value = ''; filters.forEach(f => f.value = ''); clearTimeout(timer); apply(); });
  retry.addEventListener('click', () => apply());
  $('[data-hw-prev]').addEventListener('click', () => { selectedPage--; render(); $('#hw-catalogue-title').scrollIntoView({block:'start'}); });
  $('[data-hw-next]').addEventListener('click', () => { selectedPage++; render(); $('#hw-catalogue-title').scrollIntoView({block:'start'}); });
  const form = $('#HwNativeFilters');
  form.addEventListener('submit', () => {
    form.querySelectorAll('[data-hw-preserve]').forEach(n => n.remove());
    const values = new URL(location.href).searchParams;
    for (const [k,v] of values) if (k === 'view' || (k.startsWith('hw_') && k !== 'hw_page')) {
      const input = document.createElement('input'); input.type='hidden'; input.name=k; input.value=v; input.dataset.hwPreserve=''; form.append(input);
    }
  });
  $('#hw-sort').addEventListener('change', () => form.requestSubmit());
  root.querySelectorAll('[data-hw-view]').forEach(b => b.addEventListener('click', () => {
    root.dataset.view = b.dataset.hwView;
    root.querySelectorAll('[data-hw-view]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
  }));
  if (matchMedia('(max-width:899px)').matches) $('[data-hw-native]').open = false;
  $('[data-hw-finder]').hidden = false; $('[data-hw-view-controls]').hidden = false;
  selectedPage = Math.max(1, Number(url.searchParams.get('hw_page')) || 1);
  if (active()) apply(true);
})();
